/**
 * The app's looks. Each is a set of design tokens in index.css under
 * `[data-theme="<id>"]`; components read only the tokens, so a new theme is a new
 * block of variables and an entry here, never a fork of a component.
 */
export const THEME_IDS = ['cinema', 'playful', 'noir'] as const;

export type ThemeId = (typeof THEME_IDS)[number];

export const DEFAULT_THEME: ThemeId = 'cinema';

export interface ThemeInfo {
  readonly id: ThemeId;
  readonly name: string;
  readonly description: string;
  /** Background, surface and accent colours, for the selector's preview. */
  readonly swatches: readonly [string, string, string];
}

export const THEMES: ReadonlyArray<ThemeInfo> = [
  { id: 'cinema', name: 'Premium Cinema', description: 'Minimal and cinematic; the artwork brings the colour.', swatches: ['#0b0b0d', '#1c1c21', '#e50914'] },
  { id: 'playful', name: 'Happy & Playful', description: 'Warm, bright and lively, with a touch of popcorn.', swatches: ['#1a0f2e', '#ff7a3d', '#ffc83d'] },
  { id: 'noir', name: 'Sensual Noir', description: 'A private cinema after dark: wine, rose and gold.', swatches: ['#0c0708', '#5a1622', '#c9a86a'] },
];

/** Must match the key the pre-paint script in index.html reads. */
export const THEME_STORAGE_KEY = 'zyx.theme';

/** A stored value from before themes (`light`, `dark`, `system`) reads as the default. */
export function parseTheme(stored: string | null): ThemeId {
  return THEME_IDS.find((id) => id === stored) ?? DEFAULT_THEME;
}
